<template>
    <main-content-wrapper>
        <h1 class="text-md-center">Včlanitev v Tuš klub</h1>
        <split-content text="Osebni podatki"/>
        <empty-space/>
        <v-form v-model="valid" @submit.prevent="" ref="form">
            <v-layout align-center justify-center row wrap>
                <v-flex xs12 sm6 class="pa-1">
                    <input-field v-model="name" label="Ime" :rules="checkNameLastnameRules" autofocus />
                </v-flex>
                <v-flex xs12 sm6 class="pa-1">
                    <input-field v-model="last_name" label="Priimek" :rules="checkNameLastnameRules" />
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap>
                <v-flex xs12 md6 sm6 class="pa-1">
                    <input-field v-model="street" label="Ulica" :rules="checkStreetNameRules" />
                </v-flex>
                <v-flex xs6 md3 sm3 class="pa-1">
                    <input-field v-model="house_number" label="Hišna št." :rules="checkHouseNumberRules" />
                </v-flex>
                <v-flex xs6 md3 sm3 class="pa-1">
                  <input-field v-model="house_number_ext" label="Hišna št. dodatek" :rules="checkHouseNumberExtRules" />
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap>
                <v-flex xs12 md4 sm4 class="pa-1">
                    <input-field v-model="zip" label="Poštna številka" v-on:blur="updatePlace" :rules="checkZIPNumberRules" validate-on-blur />
                </v-flex>
                <v-flex xs12 md8 sm8 class="pa-1">
                    <input-field v-model="city" label="Kraj" :rules="checkCityRules" />
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap>
                <v-flex xs12 class="pa-1" row wrap>
                    <country label="Država" v-model="country" :rules="checkCountryRules" />
                </v-flex>
                <v-flex xs12 class="pa-1" row wrap>
                    <gender-selection-field label="Spol" v-model="gender" :rules="checkGender" />
                </v-flex>
            </v-layout>
            <v-flex xs12 class="pa-1" row wrap>
                <date-picker label="Rojstni datum" v-model="date_of_birth" hint="Vnesite datum v obliki dan.mesec.leto. Primer: 1.1.1975. Minimalna starost za pridobitev Tuš klub kartice je 15 let." :rules="checkDateOfBirthClubRules" />
            </v-flex>
        </v-form>
        <v-btn depressed large block color="primary_action" @click="goNext">POTRDI</v-btn>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import InputField from "../components/InputField";
    import EmptySpace from "../components/EmptySpace";
    import DatePicker from "../components/DatePicker";
    import Country from "../components/Country";
    import utils from "../store/utils";
    import Router from '../router';
    import validations from "../components/validations";
    import GenderSelectionField from "../components/GenderSelectionField";


    export default {
        name: "JoinClubPersonal",
        data: vm => ({
            valid: false,
            checkNameLastnameRules: validations.checkNameLastname,
            checkStreetNameRules: validations.checkStreetName,
            checkHouseNumberRules: validations.checkHouseNumber,
            checkHouseNumberExtRules: validations.checkHouseNumberExt,
            checkZIPNumberRules: validations.checkZIPNumber,
            checkCityRules: validations.checkCity,
            checkCountryRules: validations.checkCountry,
            checkDateOfBirthClubRules: validations.checkDateOfBirthClub,
            checkGender: validations.checkGender,

        }),
        components: {GenderSelectionField, MainContentWrapper, Country, SplitContent, InputField, EmptySpace, DatePicker},
        computed: {
            name: utils.vuexBuildSetGet(this, 'registration', 'personal.name'),
            last_name: utils.vuexBuildSetGet(this, 'registration', 'personal.last_name'),
            street: utils.vuexBuildSetGet(this, 'registration', 'personal.street'),
            house_number: utils.vuexBuildSetGet(this, 'registration', 'personal.house_number'),
            house_number_ext: utils.vuexBuildSetGet(this, 'registration', 'personal.house_number_ext'),
            zip: utils.vuexBuildSetGet(this, 'registration', 'personal.zip'),
            city: utils.vuexBuildSetGet(this, 'registration', 'personal.city'),
            country: utils.vuexBuildSetGet(this, 'registration', 'personal.country'),
            gender: utils.vuexBuildSetGet(this, 'registration', 'personal.gender'),
            date_of_birth: utils.vuexBuildSetGet(this, 'registration', 'personal.date_of_birth')
        },
        created(){
            let canDo = this.$store.state.application.allow_join_club;
            if (!canDo){
                if (this.$store.state.application.allow_upgrade_to_club &&
                    this.$store.state.auth.authenticated_user.can_upgrade_join &&
                    this.$store.state.application.flow_data.request_type == 'UPG_JOIN'){
                    canDo = true;
                }
            }
            if (canDo){
                this.$store.dispatch('registration/checkStep', 1);
            } else {
                 Router.push('/ustvari/');
            }
        },
        mounted() {
            this.$trackPageVisit('join-club-personal');
        },
        methods: {
            updatePlace(){
                this.$store.dispatch('registration/updateCityFromZIP');

            },
            goNext(){
                let isValid = this.$refs.form.validate();
                if (isValid){
                    this.$store.dispatch('registration/goToStep', 2);
                }
            }
        }
    }
</script>

<style scoped>

</style>